import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { useBilling } from '@/components/Billing/Billing.composables';
// @ts-ignore
import VirtuallyUnlimitedExplanationMenu from '@/components/Billing/VirtuallyUnlimitedExplanationMenu.vue';
import BillingService from '@/components/Billing/billing-service';
import { Plan, ProductType } from '@/components/Billing/billing-types';

export default /*#__PURE__*/_defineComponent({
  __name: 'TeamFeaturesVirtuallyUnlimitedToggle',
  props: {
    plan: null,
    selectedTab: null,
    disableToggle: { type: Boolean }
  },
  emits: ["update-selected-tab"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'update-selected-tab', tabIndex: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	plan: Plan;
	selectedTab: number;
	disableToggle?: boolean;
}




const { useProduct } = useBilling();
const tabs = computed(() => [
	{
		text: `${BillingService.getProductAmountOfTasks(
			useProduct.value(ProductType.TeamFeatures),
			BillingService.getPlanGroup(props.plan)
		)} / member`,
	},
	{
		text: 'Virtually unlimited',
		suffixComponent: VirtuallyUnlimitedExplanationMenu,
		tabButtonSuffixClass: { 'tab-button-suffix ml-1': true },
	},
]);
const onTabClick = (tabIndex: number) => {
	emit('update-selected-tab', tabIndex);
};

return { __sfc: true,emit, props, useProduct, tabs, onTabClick }
}

})